import { Visibility as VisibilityIcon } from "@mui/icons-material";
import { Box, IconButton, Tooltip, useTheme } from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../../components/Header";
import { tokens } from "../../theme";

const FormsUser = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const token = localStorage.getItem("token");
  const [data, setData] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await fetch(
        "https://backend.placemyfilms.com/payapi/getAllPayments",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch data: ${response.statusText}`);
      }
      const responseData = await response.json();

      if (!responseData.success || !responseData.result) {
        throw new Error("Invalid response data format");
      }

      const formatDate = (isoDateString) => {
        const date = new Date(isoDateString);
        return date.toLocaleString("en-US", {
          year: "numeric",
          month: "short",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        });
      };

      const mappedData = responseData.result.map((item) => ({
        id: item.id,
        paymentId: item.paymentId,
        payID: item.payID,
        fullName: `${item.billingdetails.first_name} ${item.billingdetails.last_name}`,
        company: item.billingdetails.company_name,
        email: item.billingdetails.email_add,
        phone: item.billingdetails.phone,
        country: item.billingdetails.country,
        address: `${item.billingdetails.address1}, ${item.billingdetails.address2}, ${item.billingdetails.city}, ${item.billingdetails.state}, ${item.billingdetails.zip_code}`,
        amount: item.payments?.amount
          ? `$${parseFloat(item.payments.amount).toFixed(2)}`
          : "N/A",
        status: item.payments?.status || "N/A",
        currency: item.payments?.currency || "N/A",
        package: item.packagedetails?.title || "N/A",
        packageAmount: item.packagedetails?.amount
          ? `$${item.packagedetails.amount}`
          : "N/A",
        createdAt: formatDate(item.createdAt),
      }));

      setData(mappedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const columns = [
    { field: "payID", headerName: "Payment ID", flex: 0.5 },
    { field: "fullName", headerName: "Customer Name", flex: 1 },
    { field: "company", headerName: "Company", flex: 1 },
    { field: "email", headerName: "Email", flex: 1 },
    { field: "phone", headerName: "Phone", flex: 1 },
    { field: "country", headerName: "Country", flex: 0.7 },
    // {
    //   field: "address",
    //   headerName: "Address",
    //   flex: 1.5,
    //   cellClassName: "address-cell",
    // },
    { field: "amount", headerName: "Payment Amount", flex: 0.7 },
    { field: "currency", headerName: "Currency", flex: 0.5 },
    {
      field: "status",
      headerName: "Status",
      flex: 0.7,
      renderCell: (params) => (
        <Box
          sx={{
            backgroundColor:
              params.value === "success"
                ? colors.green[100]
                : colors.grey[100],
            color:
              params.value === "success"
                ? colors.green[900]
                : colors.grey[900],
            padding: "5px 10px",
            borderRadius: "4px",
            textTransform: "capitalize",
          }}
        >
          {params.value}
        </Box>
      ),
    },
    
    { field: "packageAmount", headerName: "Package Price", flex: 0.7 },
    { field: "createdAt", headerName: "Created At", flex: 1 },
    {
      field: "actions",
      headerName: "Actions",
      flex: 0.7,
      renderCell: (params) => (
        <Box>
          <Tooltip title="View Details">
            <Link to={`/payment/viewpayment/${params.row.payID}`}>
              <IconButton>
                <VisibilityIcon />
              </IconButton>
            </Link>
          </Tooltip>
        </Box>
      ),
    },
  ];

  const getRowClassName = (params) => {
    return "row-divider";
  };

  return (
    <Box m="20px">
      <Header
        title="Payment Records"
        subtitle="View all payment transactions in the system"
      />

      <Box
        m="0 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
            fontSize: "12px",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .address-cell": {
            whiteSpace: "normal !important",
            wordWrap: "break-word !important",
          },
          "& .name-column--cell": {
            color: colors.green[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[800],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[900],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.green[200]} !important`,
          },
          "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
            color: `${colors.grey[100]} !important`,
          },
          "& .row-divider": {
            borderBottom: `1px solid rgba(0, 0, 0, 0.1)`,
          },
        }}
      >
        <DataGrid
          rows={data}
          columns={columns}
          components={{ Toolbar: GridToolbar }}
          getRowClassName={getRowClassName}
          pageSize={10}
        />
      </Box>
    </Box>
  );
};

export default FormsUser;